export const prepareToggle = (checked: boolean, onClick: (mode: boolean) => void, label: string) => ({
  label,
  checked,
  onClick: () => {
    onClick(!checked);
  }
});
